import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { iconAdd, iconLeft, iconUser } from '../../../../assets';
import { Gap, PageHeader, Row, Col, Icon, Table,  FilterYear, FilterMonth, ReportFooter, ReportHeader, Blanko } from '../../../../components'
import API from '../../../../config/api';
import Modal from 'react-modal';
import swal from 'sweetalert';
import { useDebounce } from '../../../../utils/helpers/useDebounce';
import OvertimeForm from './OvertimeForm';
import NumberFormat from 'react-number-format';
import { tahun_bulan_tanggal, totalDate, bulan_indo } from '../../../../utils/helpers/date';

Modal.setAppElement('#root');


const EmployeeOvertime = (props) => {
    const token = props.user.token;
    const user = props.user;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [perPage, setPerPage] = useState(5);
    const perPageList = [
        {label: "5", value: 5},
        {label: "10", value: 10},
        {label: "25", value: 25},
        {label: "50", value: 50},
    ];
    const [totalTableData, setTotalTableData] = useState(0);
    const [position, setPosition] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isAddOrEdit, setIsAddOrEdit] = useState('');
    const [pageName, setPageName] = useState("Laporan Pengajuan Lembur Disetujui & Tidak Disetujui");

    const [tableData, setTableData] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [initialValues, setInitialValues] = useState({});

    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [workLocationOptions, setWorkLocationOptions] = useState([]);
    const [divisions, setDivisions] = useState([]);
    
    const year = (new Date()).getFullYear();
    const startYear = (new Date()).getFullYear() - 3;
    const [selectedYear, setSelectedYear] = useState(year);
    const [selectedDivision, setSelectedDivision] = useState(0);
    const [divisionName, setDivisionName] = useState('');
    const [requestOrAttendance, setRequestOrAttendance] = useState('request');
    const [month, setMonth] = useState(new Date().getMonth())
    const allStatus = [
        {id: 0, name: 'Menunggu'},
        {id: 1, name: 'Disetujui'},
        {id: 2, name: 'Ditolak'}
    ];
    const [status, setStatus] = useState(4);
    const [selectedOvertime, setSelectedOvertime] = useState({id: 0});

    const debouncedSearchTerm = useDebounce(searchTerm, 800);

    useEffect(() => {
        //get all employee
        API.getAllEmployee(token).then(res => {
            // setEmployeeOptions(res.data)
            // console.log(res.data)
            let eOptions = [];
            res.data.map(e => {
                eOptions.push({
                    value: e.id, label: e.name
                });
            });
            setEmployeeOptions(eOptions);

        }).catch(err => {
            console.log(err.response.data.message)
        })
        //get all leave types
        API.getAllWorkLocation(token).then(res => {
            // setWorkLocationOptions(res.data)
            // console.log(res.data)
            let wLOptions = [];
            res.data.map(e => {
                wLOptions.push({
                    value: e.id, label: e.name
                });
            });
            setWorkLocationOptions(wLOptions);

        }).catch(err => {
            console.log(err.response.data.message)
        })

        //get all division
        API.getAllDivision(token).then(res => {
            // console.log('divisi: ', res.data)
            setDivisions(res.data)
        }).catch(err => {
            console.log(err.response.data.message)
        })
    }, [])

    useEffect(() => {
        // setCurrentPage(currentPage); 
        // console.log('currentPage', currentPage)
        // console.log('perPage', perPage)
        // console.log('position: ',(currentPage - 1) * perPage)
        let mnth = parseInt(month) + 1;
        // console.log(`page/status : ${status}, year: ${selectedYear}, division: ${selectedDivision}, month: ${mnth}`)
       
        if(requestOrAttendance === 'request'){

            
            setTableColumns(employeeOvertimeColumns);

            API.getEmployeeOvertime(token, currentPage, perPage, searchTerm, selectedYear, selectedDivision, status, mnth).then((res) => {
                // console.log(res.data);
                setTableData(res.data.data)
                setTotalPage(res.data.last_page);
                setTotalTableData(res.data.total);
                setPosition((currentPage - 1) * perPage)
                setMessage('success get data overtime requests');
                // setLoading(false);
    
            }).catch(err => {
                // console.log(err.response.data.message);
                // console.log(err);
                setTableData(0);
                
    
                setMessage(err.response.data.message || 'Data Lembur Tidak Ditemukan');
                
                // setLoading(false);
            })
        }else {
            
            // alert('laporan absen lembur')
            setTableColumns(employeeOvertimeAttendanceColumns);

            API.getEmployeeOvertimeAttendance(token, selectedYear, selectedDivision, mnth).then(res => {
                // console.log(res.data);
            
                setTableData(res.data)
                // setTotalPage(res.data.last_page);
                // setTotalTableData(res.data.total);
                // setPosition((currentPage - 1) * perPage)
                setMessage('success get data overtime attendances');

            }).catch(err => {
                setTableData(0);
                // console.log(err.response.data.message)
                
    
                setMessage(err.response.data.message);
            })
        }



    }, [debouncedSearchTerm, currentPage, perPage, searchTerm, modalIsOpen, selectedYear, selectedDivision, month, status, requestOrAttendance])
    
    useEffect(() => {
        if(requestOrAttendance === 'attendance'){
            setPageName(`Laporan Absensi Lembur ${selectedDivision === 0 ? 'Semua' : ''} Karyawan ${selectedDivision === 0 ? '' : divisionName}`)
        }else{
            if(status == 1){
                setPageName(`Laporan Pengajuan Lembur Disetujui ${selectedDivision === 0 ? 'Semua' : ''} Karyawan ${selectedDivision === 0 ? '' : divisionName}`)
            }else if(status == 4){
                setPageName(`Laporan Pengajuan Lembur Disetujui & Tidak Disetujui ${selectedDivision === 0 ? 'Semua' : ''} Karyawan ${selectedDivision === 0 ? '' : divisionName}`)
    
            }else {
                setPageName(`Laporan Pengajuan Lembur Tidak Disetujui ${selectedDivision === 0 ? 'Semua' : ''} Karyawan ${selectedDivision === 0 ? '' : divisionName}`)
                
            }

        }
    }, [status, divisionName, requestOrAttendance])
    const handleMonthChange = e => {
        setMonth(e.target.value)
    }

    

    const closeModal = () => {
        setModalIsOpen(false);
    }
  
    const prevButton = () => {
        setCurrentPage(Number(currentPage - 1));
    }
    const nextButton = () => {
        setCurrentPage(Number(currentPage + 1));        

    }
    const pageNumberClick = (e) => {
        // setCurrentPage(e => e.target.id)
        setCurrentPage(Number(e.target.id));
    }
    const changePerPage = (e) => {
        setPerPage(Number(e.target.value))
    }

    const handleChangeYearFilter = (e) => {
        setSelectedYear(e.target.value);
       
    }


    const pageNumbers = [];
    
    let i = 0;
    do {
        i++;
        // console.log(`halaman sekarang,`, i);
        pageNumbers.push(i);
    } while(i < totalPage)

    const renderPageNumbers = pageNumbers.map(number => {
        return (
          <a
            key={number}
            id={number}
            onClick={pageNumberClick}
            className={currentPage == number ? 'active' : ''}
          >
            {number}
          </a>
        );
      });
    
    const handleChangeDivision = (division) => {
        setSelectedDivision(division.id)
        setDivisionName(division.name)
        // setGroup(division)
    }
    const handleRequestOrAttendance = (value) => {
        setRequestOrAttendance(value)
    }
    
    const handleChangeStatus = (status) => {
        setStatus(status.id)
    }

    const handleAdd = () => {
        setIsAddOrEdit('add')

        setInitialValues({
            employee_id: [],
            no: '',
            date: '',
            start_from: '',
            ends_on: '',
            late_tolerance: '',
            break_duration: '',
            desc: '',
            overtime_location: [],
            approved_by: [],
            paid_by: '',
            status: 1,
        })
        setModalIsOpen(true)
        
       
    }

    const handleEdit = (row) => {
        // console.log(row)
        setIsAddOrEdit('edit');
        setInitialValues({
            id: row.id,
            employee_id: {label: row.employee_name, value: row.employee_id},
            no: row.no,
            date: row.date,
            start_from: row.start_from,
            ends_on: row.ends_on,
            late_tolerance: row.late_tolerance,
            break_duration: row.break_duration,
            desc: row.desc,
            overtime_location: {label: row.overtime_location_name, value: row.overtime_location},
            approved_by: {label: row.approver_name, value: row.approved_by},
            paid_by: row.paid_by,
            status: row.status
          })
        setModalIsOpen(true)
    }

    const handleDetail = (row) => {
        //set modal detail open
        console.log('detail', row)
    }

    const handleDelete = (row) => {
        // console.log(row)
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this overtime data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                // console.log('Call API delete Departemen');
                // console.log(currentPage)
                // console.log(tableData)
                // console.log(totalPage)
        let mnth = parseInt(month) + 1;

                if(currentPage === totalPage){ //jika di halaman terakhir
                    // console.log('halaman terakhir')
                    setCurrentPage(currentPage); 

                    return API.deleteOvertimeEmployee(token, row.id).then(res => {
                        swal({
                            title: 'Berhasil',
                            text: 'Lembur Berhasil Dihapus',
                            icon: "success",
                          });
                        // console.log('call branch Data lagi');
                        
                            API.getEmployeeOvertime(token, currentPage, perPage, searchTerm, selectedYear, selectedDivision, status, mnth).then((res) => {
                                // console.log(res.data.data);
                                
                                setTableData(res.data.data)
                                setTotalPage(res.data.last_page);
                                setTotalTableData(res.data.total);
                                setPosition((currentPage - 1) * perPage)
                                // console.log('tetap di halaman')
                                setMessage('success get data overtimes');
                            
                                // setLoading(false);
                            }).catch(err => {
                                // console.log(err.response.data.message);
                                // console.log(err);
                                setCurrentPage(currentPage - 1)
                                // setTableData(0);
                                setMessage(err.response.data.message || 'Lembur Tidak Ditemukan');
                                
                                // setLoading(false);
                            })
                        
                        
                    }).catch(err => {
                        console.log(err);
                        // setLoading(false);
                    })
                    
                }else {
                    // console.log('bukan halaman terakhir')
                    return API.deleteOvertimeEmployee(token, row.id).then(res => {
                        swal({
                            title: 'Berhasil',
                            text: 'Lembur Berhasil Dihapus',
                            icon: "success",
                          });
                        // console.log('call branch Data lagi');
                        
                            API.getEmployeeOvertime(token, currentPage, perPage, searchTerm, selectedYear, selectedDivision, status, mnth).then((res) => {
                                // console.log(res.data.data);
                                setTableData(res.data.data)
                                setTotalPage(res.data.last_page);
                                setTotalTableData(res.data.total);
                                setPosition((currentPage - 1) * perPage)
                                setMessage('success get data overtimes');
                                // setLoading(false);
                            }).catch(err => {
                                // console.log(err.response.data.message);
                                // console.log(err);
                                setTableData(0);
                                setMessage(err.response.data.message || 'Lembur Tidak Ditemukan');
                                
                                // setLoading(false);
                            })
                        
                        
                    }).catch(err => {
                        console.log(err);
                        // setLoading(false);
                    })
                }
                
            }
            else {
            //   swal("Your imaginary file is safe!");
            //   setLoading(false);

            }
          });
    }

    const employeeOvertimeColumns = [
        {Header: 'No',
            Cell: (row) => {
                // console.log(row)
                // console.log(row.cell.row.index)
                // console.log(position)
                let startFrom = position + 1;
                return <div>{startFrom +row.cell.row.index}.</div>;
                console.log(row);
                // return <div>{row.cell.row.index+1}.</div>;
                
            }
        },
        // {Header: 'Id', accessor: 'id', show: false},
        {Header: 'No. Lembur', accessor: 'no'},
        {Header: 'Nama', accessor: 'employee_name'},
        {Header: 'Dept.', accessor: 'employee_division'},
        {Header: 'Tim/Grup Kerja', accessor: 'group_name'},
        {Header: 'Jenis Lembur', accessor: 'overtime_day_name'},
        {Header: 'Lokasi', accessor: 'overtime_location_name'},
        {Header: 'Jam', accessor: 'start_from', Cell: (row) => {
            const start_from = row.cell.row.original.start_from;
            const ends_on = row.cell.row.original.ends_on;

            return <div align="center">{`${start_from} - ${ends_on}`}</div>;
        }},
        {Header: 'Tanggal', accessor: 'date'},
        {Header: 'Upah Lembur', accessor: 'paid_by', Cell: (row) => {
            const paid_by = row.cell.row.original.paid_by;
            //jika nilainya 1, libur, jika 0, masuk
            return <div>{paid_by === 1 ? 'Uang' : 'Cuti'}</div>
        }},
        {Header: 'Jumlah', accessor: 'amount', Cell: (row) => {
            const amount = row.cell.row.original.amount;
            const paid_by = row.cell.row.original.paid_by;

            //jika nilainya 1, libur, jika 0, masuk
            return paid_by === 1 ? <NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={false}  prefix={'Rp. '} /> : `${amount} Hari`
        }},
        {Header: 'Status', accessor: 'status', 
        Cell: (row) => {
            const status = row.cell.row.original.status;
            //jika nilainya 1, libur, jika 0, masuk
            return <div>{status === 1 ? 'Disetujui Atasan' : status === 2 ? 'Disetujui Div. HR' : status === 3 ? (
               'Ditolak'
              ) : (
                'Menunggu Persutujuan'
              )}</div>
            // return <div>{status ? 'Disetujui' : 'Menunggu Persetujuan'}</div>;
            
        }},
        {Header: 'Aksi', className:"no-print",
            Cell: row => (
                <div className="edit-delete-wrapper">
                    <button className="detail-button" onClick={() => {printOvertimeLetter(row.row.original)}}>Detail</button> 
                    <button className="edit-button" onClick={() => {handleEdit(row.row.original)}}>Edit</button> 
                    <button className="delete-button" onClick={() => {handleDelete(row.row.original)}}>Delete</button>
                </div>
            )
        },
    ];

    const employeeOvertimeAttendanceColumns = [
        {Header: 'No',
        Cell: (row) => {
            // console.log(row)
            // console.log(row.cell.row.index)
            // console.log(position)
            let startFrom = position + 1;
            return <div>{startFrom +row.cell.row.index}.</div>;
            console.log(row);
            // return <div>{row.cell.row.index+1}.</div>;
            
        }
        },
        // {Header: 'Id', accessor: 'id', show: false},
        {Header: 'No. Lembur', accessor: 'no'},
        {Header: 'Nama', accessor: 'employee_name'},
        {Header: 'Dept.', accessor: 'employee_division'},
        {Header: 'Tim/Grup Kerja', accessor: 'group_name'},
        {Header: 'Jenis Lembur', accessor: 'overtime_day_name'},
        {Header: 'Lokasi', accessor: 'overtime_location_name'},
        {Header: 'Jam', accessor: 'start_from', Cell: (row) => {
            const start_from = row.cell.row.original.start_from;
            const ends_on = row.cell.row.original.ends_on;

            return <div align="center">{`${start_from} - ${ends_on}`}</div>;
        }},
        {Header: 'Tanggal', accessor: 'date'},
        {Header: 'Upah Lembur', accessor: 'paid_by', Cell: (row) => {
            const paid_by = row.cell.row.original.paid_by;
            //jika nilainya 1, libur, jika 0, masuk
            return <div>{paid_by === 1 ? 'Uang' : 'Cuti'}</div>
        }},
        {Header: 'Jumlah', accessor: 'amount', Cell: (row) => {
            const amount = row.cell.row.original.amount;
            const paid_by = row.cell.row.original.paid_by;

            //jika nilainya 1, libur, jika 0, masuk
            return paid_by === 1 ? <NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={false}  prefix={'Rp. '} /> : `${amount} Hari`
        }},
        {Header: 'Status', accessor: 'status', 
        Cell: (row) => {
            const status = row.cell.row.original.status;
            //jika nilainya 1, libur, jika 0, masuk
            return <div>{status === 1 ? 'Disetujui Atasan' : status === 2 ? 'Disetujui Div. HR' : status === 3 ? (
            'Ditolak'
            ) : (
                'Menunggu Persutujuan'
            )}</div>
            // return <div>{status ? 'Disetujui' : 'Menunggu Persetujuan'}</div>;
            
        }},
        {Header: 'Masuk', Cell: (row) => {
            const time_in = row.cell.row.original.time_in;
            const time_in_img = row.cell.row.original.time_in_img;
            return <div>
                {time_in} 
                {time_in_img && <><br /><br /><img src={time_in_img} alt="foto absen" width="30" height="30" /></>}
            </div>

        }},
        {Header: 'Pulang', Cell: (row) => {
            const time_out = row.cell.row.original.time_out;
            const time_out_img = row.cell.row.original.time_out_img;
            return <div>
                {time_out} 
                {time_out_img && <><br /><br /> <img src={time_out_img} alt="foto absen" width="30" height="30" /></>}
            </div>

        }},
        // {Header: 'Status Absen', accessor: 'attendance_status'}

        // {Header: 'Aksi', className:"no-print",
        //     Cell: row => (
        //         <div className="edit-delete-wrapper">
        //             <button className="detail-button" onClick={() => {printOvertimeLetter(row.row.original)}}>Detail</button> 
        //             <button className="edit-button" onClick={() => {handleEdit(row.row.original)}}>Edit</button> 
        //             <button className="delete-button" onClick={() => {handleDelete(row.row.original)}}>Delete</button>
        //         </div>
        //     )
        // },
    ];
    const handlePrint = () => {
        window.print();
    }

    const printOvertimeLetter = (overtime) => {
        // console.log(overtime)
        setPageName('print-blanko')
        if(overtime.id === 0){
            setModalIsOpen(!modalIsOpen)
            // alert('print blankoooo')
        }
        setSelectedOvertime(overtime)
        
    }

    return (
        <>
             <PageHeader
                title="Lembur Karyawan"
                subtitle={props.user.client_id}
                name={props.user.name}
                photo={iconUser}
            />
            <Gap height={20} />
            {
                pageName === 'print-blanko' ? <>
                <Blanko type="overtime" company={user.info.company} value={selectedOvertime} setPageName={setPageName} />
                </> :
           <>
            <Row style={{position: 'relative'}}>
                <Col>
                <Link to='/employee' className="back-button" >                    
                    <Icon icon={iconLeft} color="#fff" />
                    <p>Back</p>
                </Link>
                {/* <button onClick={handleAdd} className="back-button">
                            Back

                </button> */}
                </Col>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 5, marginBottom: 5, position: 'absolute', left: '110px'}}>
                        <p className={`filter-group ${requestOrAttendance == 'request' ?'active': ''}`} onClick={() => handleRequestOrAttendance('request')}>Pengajuan</p>    
                        <p className={`filter-group ${requestOrAttendance == 'attendance' ?'active': ''}`} onClick={() => handleRequestOrAttendance('attendance')}>Absensi Lembur</p>    
                        
                </div>
                <Col style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10, marginBottom: 5}}>
                        <p className={`filter-group ${selectedDivision == 0 ?'active': ''}`} onClick={() => handleChangeDivision({id: 0})}>Semua</p>    
                        {divisions && divisions.map(division => (
                            <p key={division.name} className={`filter-group ${selectedDivision == division.id ?'active': ''}`} onClick={() => handleChangeDivision(division)}>                    
                            {division.code}
                            </p>
                        ))
                        }
                </Col>
                    
                {/* filter tahun dan bulan */}
                <Col style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <p style={{fontSize: 14, marginRight: 5}}>Periode : </p>
                    
                    <div style={{marginLeft: 5}}>
                        <FilterYear year={year} startYear={startYear} selectedYear={selectedYear} handleChange={handleChangeYearFilter} />
                    </div>
                    <div style={{marginLeft: 5}}>
                        <FilterMonth handleChange={handleMonthChange} month={month} className="select-month" />
                
                    </div>
                    <div onClick={() => handlePrint()} className="print-button" style={{marginLeft: '5px', padding: '0 10px', height: '35px', border: '1px solid #eee'}}><span style={{fontSize: '22px', marginRight: '3px'}}>&#128424;</span>Print</div>
                    
                </Col>
                
            </Row>
            {requestOrAttendance === 'request' &&
                <Row>
                    <p className={`filter-group ${status == 4 ?'active': ''}`} onClick={() => handleChangeStatus({id: 4})}>Semua</p>    
                    {allStatus && allStatus.map(st => (
                        <p key={st.name} className={`filter-group ${status == st.id ?'active': ''}`} onClick={() => handleChangeStatus(st)}>                    
                        {st.name}
                        </p>
                    ))
                    }   
                </Row>
            }
            <ReportHeader company={user.info.company} month={month} selectedYear={selectedYear} page={pageName} />
            <Row>
                <div style={{overflowX: 'auto', flex:1}}>
                    <div className="table-control">
                        <div className="limit">
                            <span>Show :</span>
                            <select onChange={changePerPage} value={perPage}>
                            {perPageList.map(perPage => {
                                return (
                                <option key={perPage.value} value={perPage.value}>
                                {perPage.label}
                                </option>
                                )
                                })
                            }
                            </select>
                            <span>Entries</span>

                        </div>
                    

                    <div className="search">
                        <input type="text"
                            placeholder="Search here..."
                            value={searchTerm || ''}
                            onChange={e => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>
                    
                    <button onClick={handleAdd} className="add-button">
                            <Icon icon={iconAdd} color="#fff" />
                            Buat Lembur

                    </button>
                    
                    </div>
                 
                 
        
                        
                        {tableData ? 
                        <div className="print-table">
                        <Table type="dataTable" tableData={tableData} tableColumns={tableColumns} />
                        <ReportFooter className="section-to-print footer" />
                        </div>
                        : <><Gap height={30} /><h2 align="center">{message}</h2></>
                    }
                    
                    </div>
                </Row>
                

                {/* //jika tidak ada table data sembunyikan */}
                
    
                {tableData ? requestOrAttendance === 'request' &&
                    <div className="pagination">
                        <div className="pagination-info">
                            <span>Showing {position + 1} to {( currentPage != totalPage ) ? position + 1 * perPage : totalTableData } of {totalTableData} entries</span> <br />
                        </div>
                        <div className="pagination-control">
                            <button onClick={() => prevButton()} disabled={currentPage <= 1}>&laquo;</button>
                            {renderPageNumbers}
                            <button onClick={() => nextButton()} disabled={currentPage >= totalPage}>&raquo;</button>
    
                        </div>
                    </div>
                        : null
                }
                </>
                 }
            <Modal 
                onRequestClose={() => setModalIsOpen(false)}
                isOpen={modalIsOpen}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                      },
                    content: {
                        border: '1px solid #222',
                        padding:0,
                        top: '25px',
                        left: '400px',
                        right: '400px',
                        bottom: '50px',
                    }
                }}
            >
                <div className="modal-container">
                <div className="modal-header">
                    <h2 className="modal-title">{(isAddOrEdit == 'add') ? 'Tambah' : 'Edit' } Lembur</h2>
                    <div onClick={() => printOvertimeLetter({id: 0})} className="print-button" style={{ cursor: 'pointer', marginLeft: 'auto', marginRight: '5px'}}><span style={{fontSize: '20px'}}>&#128424;</span></div>
                    <button className="close-modal" onClick={() => setModalIsOpen(false)}>X</button>
                </div>
                <OvertimeForm employeeOptions={employeeOptions} workLocationOptions={workLocationOptions} token={token} closeModal={closeModal} isAddOrEdit={isAddOrEdit} initialValues={initialValues} />
                

                </div>
            </Modal>
    
        </>
    )
}

const reduxState = (state) => ({
    isLogin: state.isLogin,
    user: state.user,
    isLoading: state.isLoading

})
  
  
const reduxDispatch = (dispatch) => ({
    loading : (data) => dispatch(setLoading(data)),

    

})
export default connect(reduxState, reduxDispatch)(EmployeeOvertime)
